var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack243({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.14,11.47l-1,1.27a5.66,5.66,0,0,1-1.4-1,3.65,3.65,0,0,1-1.11.69,3.9,3.9,0,0,1-1.39.22,3.1,3.1,0,0,1-2.42-.9,2.31,2.31,0,0,1-.63-1.6,2.43,2.43,0,0,1,.5-1.49A3.84,3.84,0,0,1,6.16,7.54a4.09,4.09,0,0,1-.66-1,2.07,2.07,0,0,1-.23-.89A1.68,1.68,0,0,1,5.9,4.33a2.62,2.62,0,0,1,1.77-.54,2.55,2.55,0,0,1,1.75.56A1.84,1.84,0,0,1,10,5.74a1.73,1.73,0,0,1-.31,1A4,4,0,0,1,8.48,7.79L9.67,9.37a4.49,4.49,0,0,0,.37-1l1.48.34a8.24,8.24,0,0,1-.38,1.16,3.39,3.39,0,0,1-.35.61,7.28,7.28,0,0,0,.71.57A4.66,4.66,0,0,0,12.14,11.47ZM7,8.59a2.22,2.22,0,0,0-.85.69,1.5,1.5,0,0,0-.28.83,1.18,1.18,0,0,0,.35.87,1.3,1.3,0,0,0,.94.33,1.92,1.92,0,0,0,.74-.15,3.25,3.25,0,0,0,.78-.5ZM7.66,6.8l.44-.34a1,1,0,0,0,.49-.75.7.7,0,0,0-.23-.54A.89.89,0,0,0,7.72,5a.9.9,0,0,0-.62.19.58.58,0,0,0-.22.46,1.2,1.2,0,0,0,.37.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack243);
export default __webpack_public_path__ + "static/media/Symbolpack_2_43.f00532de2c4f94db9c0b127d212d15e2.svg";
export { ForwardRef as ReactComponent };